import { HttpRequest } from "../utils";
import { openFileInNewTab } from "../utils/file-download";
import type { ChargeContract } from "./chargeContract";

const httpRequest = new HttpRequest();

export type { ChargeContract };

/** Read-only: the caller tenant's current platform charge contract (or null). */
export const getMy = () => httpRequest.get("/bil/my/charge-contract");

/** Open the tenant's charge-contract PDF inline in a new tab. */
export const openContractPdf = (id: string) =>
  openFileInNewTab(`/bil/my/charge-contract/${id}/pdf`);
